import { isImage, isVideo } from './'

export const isNonMedia = (contentType = '') => {
  return !isImage(contentType) && !isVideo(contentType)
}

export default isNonMedia
